import { CHECK_IF_MDN_SMS_CAPABLE_SUCCESS } from "../actions/types";

const initialState = {
  verifiedDeviceEncrypted: "",
  email: "",
  mdn: "",
  encryptedEmail: "",
  encryptedMdn: "",
  sendPinToEmail: false,
  mfaAllowed: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_IF_MDN_SMS_CAPABLE_SUCCESS:
      return { ...action.payload };
    default:
      return state;
  }
};
